export const getLoginFeedback = (error, method = "password") => {
  const cause = error?.error || error;
  const status = cause?.response?.status || cause?.status;
  const raw = cause?.response?.data?.message || cause?.message;
  const feedback = (title, message, severity = "error") => ({
    title,
    message,
    severity,
  });

  if (status === 429) {
    return feedback(
      "Please wait before trying again",
      "Too many requests were made. Wait a few minutes, then try again.",
      "warning"
    );
  }
  if (status >= 500) {
    return feedback(
      "Sign-in is temporarily unavailable",
      "Please try again shortly. If the problem continues, contact support."
    );
  }
  if (
    cause?.code === "ERR_NETWORK" ||
    cause?.code === "ECONNABORTED" ||
    cause?.code === "ETIMEDOUT" ||
    raw === "Network Error"
  ) {
    return feedback(
      "Unable to connect",
      "Check your internet connection and try again."
    );
  }
  if (method === "password") {
    if (raw === "Account not verified. Please check your email.") {
      return {
        ...feedback(
          "Verify your email to sign in",
          "Open the verification email in your inbox. If you cannot find it, check your spam folder or request another email.",
          "info"
        ),
        canResend: true,
      };
    }
    if (raw === "This account uses Microsoft SSO. Please login with SSO.") {
      return feedback(
        "Sign in with Microsoft",
        "This account uses Microsoft sign-in. Select Continue with Microsoft below.",
        "info"
      );
    }
    if (raw === "Your login is blocked. Please contact support.") {
      return feedback(
        "Sign-in is restricted",
        "Please contact support for help accessing your account."
      );
    }
    if (status === 401 || raw === "Invalid credentials") {
      return feedback(
        "Email or password is incorrect",
        "Check your details and try again, or select Forgot password to reset your password."
      );
    }
  }
  return feedback(
    method === "microsoft"
      ? "Microsoft sign-in could not start"
      : "Unable to sign in",
    "Please try again. If the problem continues, contact support."
  );
};
